import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NoResultsMessageComponent} from '@common/core/ui/no-results-message/no-results-message.component';
import {SvgImageModule} from '../svg-image/svg-image.module';

@NgModule({
    declarations: [
        NoResultsMessageComponent,
    ],
    imports: [
        CommonModule,
        SvgImageModule,
    ],
    exports: [
        NoResultsMessageComponent,
    ]
})
export class NoResultsMessageModule {
}
